<template>
  <div class="flex flex-col h-screen w-screen">
    <navbar class="w-screen" />
    <div class="mobile-banner flex flex-col items-center">
      <div class="icon-container mt-20">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-smartphone"
        >
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
          <line x1="12" y1="18" x2="12.01" y2="18"></line>
        </svg>
      </div>
      <p class="mt-5 max-w-xs text-center">
        For the best experience please view our dashboard on a desktop or laptop
      </p>
      <hr />
      <p class="max-w-xs text-center">
        <b>Have any quesitons?</b> Feel free to post your queries, feedback and
        comments over on our <span class="blue-text">forum</span>. We're here
        for you
      </p>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/modules/home/components/Navbar.vue";
@Component({
  components: {
    Navbar,
  },
})
export default class MobileBanner extends Vue {}
</script>

<style scoped>
.blue-text {
  color: #0057ea;
  @apply font-bold;
}

hr {
  background: gray;
  width: 90%;
  height: 1px;
  @apply my-8;
}

.mobile-banner {
  height: 80%;
  width: 90%;
  @apply m-auto;
  background: white;
}

.icon-container {
  height: 100px;
  width: 100px;
  @apply bg-primary;
  @apply rounded;
  @apply flex items-center justify-center;
}
</style>
